import React from 'react';
import * as DateFns from 'date-fns';
import { Link, useLocation } from 'react-router-dom';

import { cleanFetch, routeToDate } from '../../../../helpers';
import { FORMAT_DATE_ROUTE } from '../../../../config/constants';

import '../WeekSelector/styles.scss';

export const DaySelector = () => {
  
  const { pathname } = useLocation();
  const selectedDate = routeToDate(pathname, 2);
  
  const currentDate = new Date();
  
  return (
    <>
      <Link
        to={`/monitor/${DateFns.format(DateFns.subDays(selectedDate, 1), FORMAT_DATE_ROUTE)}`}
        onClick={() => cleanFetch()}
      >
        <div className="arrow-l" id={'selector-date-previous'}>
          <i className="mdi mdi-arrow-left" />
        </div>
      </Link>
      <Link
        to={`/monitor/${DateFns.format(new Date(currentDate), FORMAT_DATE_ROUTE)}`}
        onClick={() => cleanFetch()}
      >
        <div className="today-s" id={'button-today'} style={{ width: '101px', margin: '0' }}>
          Today
        </div>
      </Link>
      <Link
        to={`/monitor/${DateFns.format(DateFns.addDays(selectedDate, 1), FORMAT_DATE_ROUTE)}`}
        onClick={() => cleanFetch()}
      >
        <div className="arrow-r" id={'selector-date-next'}>
          <i className="mdi mdi-arrow-right" />
        </div>
      </Link>
    </>
  );
};
